
<template>
  <div>
    <!-- <mheader></mheader> -->
    <div style="width: 1300px; margin: 0 auto" id="v-content"
      :style="{ minHeight: Height + 'px' }">
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font mb-3">
          <img src="../../static/images/kucun.png" style="width: 1.5rem; height: 1.5rem" class="mb-lg-1" alt="" />
          <span class="p-1" style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            ">
            业务员图片上传
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ tableData.length }}</span>
              天数据
            </span>
          </span>
          <span class="float-right span_close" style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            " @click="$router.go(-1)">
            &times;
          </span>
        </p>

        <el-card v-for="(res, index1) of tableData" :key="index1" style="margin:0 20px 10px 20px;">
          <div slot="header" style="display:flex;align-items:center;justify-content: space-between;">
            <div>添加时间:<span style="padding-left: 5px;color:blue;">{{ res.shortime }}</span></div>
            <!-- <el-button v-if="res.shortime == time" type="primary" size="small">上传图片</el-button> -->
          </div>
          <div style="display:flex;align-items:center;flex-wrap: wrap;">
             <el-image
              style="width: 100px; height: 100px;margin-bottom:10px;margin-right:10px;"
              v-for="(item, index) of res.image" :key="index" :src="item"
              :preview-src-list="res.image"
              :initial-index="index"
              ></el-image>
            <el-upload
              v-if="res.shortime == time"
              class="upload"
              action="http://hyapi.hyey.cn/Dls/UpYwyPic"
              :multiple="false"
              name="image"
              :data="formData"
              :file-list="fileList"
              :on-success="handleSuccess"
              list-type="picture-card">
              <i class="el-icon-upload" style="font-size:50px;"></i>
            </el-upload>
          </div>
        </el-card>

         <p class="text-center">
          <img src="../../static/images/tuding.png" style="width: 1.5rem; height: 1.5rem" alt="" />
        </p>
      </div>
      <!-- container -->
    </div>

  </div>
</template>
<script>
export default {
  name: "ywyUpload",
  data() {
    return {
      Record: 0, //总记录数
      Height: 0,
      tableData: [],
      time: "",
      fileList: [],
      formData: {
        username: "",
        tokenid: "",
        phone_uuid: ""
      }
    };
  },

  methods: {
    getList() {
      this.$http.post('Dls/GetYwyPic', {}).then(res => {
        if (res.data.isok) {
          this.tableData = res.data.data;

          let isShow = true;

          this.tableData.forEach(res => {
            if (res.shortime == this.time) {
              isShow = false;
            }
            let arr = []
            res.imagelist.forEach(item => {
              arr.push(`https://hyapi.hyey.cn${item.pic}`)
              this.$set(item, 'pic', `https://hyapi.hyey.cn${item.pic}`)
            })
            this.$set(res, 'image', arr)
          })

          if (isShow) {
            this.tableData.unshift({
              shortime: this.time,
              imagelist: []
            })
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    handleSuccess(response, file, fileList) {
      if (response.isok) {
        this.fileList = []
        this.getList()
      } else {
        this.$message.error(response.message)
      }
    },
    YearDate () {
      let time = new Date();
      let Y = time.getFullYear();
      let M = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
      let D = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
      let son = Y +  M + D + '';
      return son
    }
  },
  mounted() {
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.formData.username = window.sessionStorage.getItem('username')
    this.formData.tokenid = window.sessionStorage.getItem('tokenid')
    this.formData.phone_uuid = window.sessionStorage.getItem('phone_uuid')
    this.time = this.YearDate()
   this.getList()
  },
};
</script>
<style scoped>
.table-hover>tbody>tr:hover {
  background-color: #dee2e6 !important;
}

.font {
  font-size: 15px;
}

/deep/ .upload .el-upload--picture-card {
  width:100px;
  height:100px;
  line-height:100px;
  margin-bottom:10px;
}

/deep/ .upload .el-upload-list__item {
  width:100px;
  height:100px;
}

.font_yz {
  font-size: 1px;
  color: red;
}

.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}

.heit {
  height: 1.5rem;
}

.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}

.jz_middle {
  vertical-align: middle;
}

.head-style {
  display: block;
  width: 100%;
  height: 50px;
  background: #3190e8;
}
</style>



// WEBPACK FOOTER //
// src/pages/ywyUpload.vue